<script lang="ts">
	import { clickOutside } from '../directive/click-outside';
	import { offset, shift, type Placement } from 'svelte-floating-ui/dom';
	import { createFloatingActions } from 'svelte-floating-ui';
	import { fly } from 'svelte/transition';

	export let placement: Placement = 'bottom';
	export let disabled = false;
	export let onTop = false;
	export let strategy: 'fixed' | 'absolute' = 'absolute';
	export let autoclose: boolean = false;
	const [floatingRef, floatingContent] = createFloatingActions({
		placement,
		strategy: strategy,
		middleware: [offset(4), shift()]
	});
	let buttonRef: HTMLElement | null = null;
	export let showTooltip = false;
	export let style = '';
</script>

<div class="relative flex">
	<button
		class="space-between flex-between relative flex flex-1"
		{style}
		use:floatingRef
		on:click|preventDefault|stopPropagation={() => {
			if (disabled) return;
			showTooltip = !showTooltip;
		}}
		bind:this={buttonRef}
		type="button"
		class:pointer-events-none={disabled}
	>
		<slot name="trigger">
			<span class="missing">trigger</span>
		</slot>
	</button>
	{#if showTooltip}
		<button
			id="tooltip"
			class={strategy === 'absolute' ? 'z-10 w-auto min-w-full' : 'z-10'}
			class:z-50={onTop}
			use:floatingContent
			use:clickOutside={buttonRef}
			in:fly={{ y: -10, duration: 100 }}
			on:outclick={() => {
				showTooltip = false;
			}}
			on:click|stopPropagation={() => {
				if (autoclose) {
					showTooltip = false;
				}
			}}
		>
			<slot name="dd">
				<span class="missing">tooltip</span>
			</slot>
		</button>
	{/if}
</div>
